const API_URL = process.env.REACT_APP_API_URL;

const applyApi = (request) =>
  fetch(`${API_URL}/sibur-referral-program/invite?token=${request.ref}`, {
    method: 'POST',
    headers: {
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      first_name: request.firstName,
      last_name: request.lastName,
      phone: request.phone,
      email: request.email,
      vacancy_id: request.vacancyId,
      form_token: request.formToken,
      about_me: request.bio,
      cv_link: request.link
    })
  }).then((response) => response.json());

/*
curl -X POST \
  'http://new.vcv.local:8080/api/sibur-referral-program/referral-invite?token=v2Ik3jHvy4945jHH' \
  -H 'Content-Type: application/json' \
  -H 'cache-control: no-cache' \
  -d '{
  "first_name": "test_1",
  "last_name": "test_2",
  "email": "test@test.com",
  "phone": "12341234567890",
  "vacancy_id": 4779,
  "form_token": "u38lqp",
  "referral_first_name": "super_ref",
  "referral_last_name": "super_ref",
  "referral_email": "ref@ref.ru",
  "referral_comment": "годный малый"
}'
 */

const recommendApi = (request) => {
  return fetch(`${API_URL}/sibur-referral-program/referral-invite?token=${request.ref}`, {
    method: 'POST',
    headers: {
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      first_name: request.firstName,
      last_name: request.lastName,
      email: request.email,
      phone: request.phone,
      vacancy_id: request.vacancyId, //4779,
      form_token: request.formToken, //'u38lqp',
      referral_first_name: request.refFirstName,
      referral_last_name: request.refLastName,
      referral_email: request.refEmail,
      referral_comment: request.refComment
    })
  }).then((response) => response.json());
};

const uploadFileApi = (file) => {
  const formData = new FormData();
  formData.append('file', file);

  return fetch(`${API_URL}/custom-process/files/upload`, {
    method: 'POST',
    body: formData,
    headers: {
      'Cache-Control': 'no-cache',
    }
  }).then((response) => response.json());
};

export const sendApplyRequest = (values) => {
  return uploadFileApi(values.file)
    .then((response) => applyApi({ ...values, ...response }));
};

export const sendRecommendRequest = (values) => {
  return recommendApi(values);
};
